import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

export interface IGetAirportsResponse {
  status?: boolean;
  message?: string;
  data?: {
    id?: number;
    name?: string;
    city?: string;
    country?: string;
    iata?: string;
  }[];
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetAirportsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getAirportsAsync = createAsyncThunk(
  'flights/airports',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(`/flights/airports`, config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const airportsGetSlice = createSlice({
  name: 'flights/airports/get',
  initialState,
  reducers: {
    resetGetAirports: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAirportsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getAirportsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetAirportsResponse;
      })
      .addCase(getAirportsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetAirportsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetAirports } = airportsGetSlice.actions;

export default airportsGetSlice.reducer;
